import React, { FC, useEffect, useRef } from 'react';

import { MeAuthContext_me as Me } from 'Jsx/ContextApis/AuthContext/graphql/types/MeAuthContext';
import useMe from 'Jsx/Shared/Hooks/useMe';
import { UserType } from 'Jsx/Types/UserType';

import trackUserActivity from './trackUserActivity';
import { PageViewType, UserActivityEvent, PageIdentifierType } from './types';

interface PageViewProps {
  page: PageViewType;
  id?: number;
}

export function trackPageView({
  user,
  id,
  page,
  pageIdentifier,
}: {
  user?: Me | UserType;
  id?: number;
  page: PageViewType;
  pageIdentifier?: PageIdentifierType;
}) {
  if (user) {
    trackUserActivity({
      event: UserActivityEvent.PAGE_VIEW,
      data: {
        item_id: id,
        item_type: page,
        path: window.location.href.split('?')[0],
        origin_path: window.document.referrer.split('?')[0],
        page_identifier: pageIdentifier,
      },
      user: {
        segment: user.segmentationKey!,
        username: user.username!,
      },
    });
  }
}

const PageView: FC<PageViewProps> = ({ page, id, children }) => {
  const { me } = useMe();
  const tracked = useRef<boolean>(false);

  useEffect(() => {
    if (me && !tracked.current) {
      trackPageView({
        user: me,
        id,
        page,
      });
      tracked.current = true;
    }
  }, [me]);

  return <React.Fragment>{children}</React.Fragment>;
};

export default PageView;
